import { useEffect } from "react";

/**
 * Escape hook.
 *
 * https://stackoverflow.com/a/59963095
 * https://creativecommons.org/licenses/by-sa/4.0/
 */
const useEscape = ({ onEscape, enabled }: { onEscape?: () => void; enabled?: boolean } = {}) => {
	useEffect(() => {
		if (typeof enabled === "boolean" && !enabled) return;

		const handleEsc = (event: any) => {
			if (event.keyCode === 27) onEscape && onEscape();
		};
		window.addEventListener("keydown", handleEsc);

		return () => {
			window.removeEventListener("keydown", handleEsc);
		};
	}, [onEscape, enabled]);
};

export default useEscape;
